/* Premium product page enhancements:
   - keeps the "selected value" label next to each variant option in sync
   - moves the Size guide link into the Size option header when both exist */
(function () {
  function initInfo(info) {
    if (info.dataset.premiumPdpInit) return;
    info.dataset.premiumPdpInit = 'true';

    const syncSelected = () => {
      info.querySelectorAll('.variant-option').forEach((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        const target = fieldset.querySelector('[data-selected-value]');
        if (checked && target) target.textContent = checked.value;
      });
    };

    info.addEventListener('change', (e) => {
      if (e.target && e.target.matches('input[type="radio"]')) syncSelected();
    });

    const section = info.closest('section') || document;

    const isPreorderVariant = (v) =>
      !!v &&
      v.available &&
      v.inventory_policy === 'continue' &&
      v.inventory_management === 'shopify' &&
      (v.inventory_quantity == null || v.inventory_quantity <= 0);

    const applyPreorder = (variant) => {
      const btn = section.querySelector('.product-form__submit');
      const btnText = btn ? btn.querySelector('span') : null;
      const note = section.querySelector('[data-preorder-note]');
      if (!btn || !btn.dataset.preorderLabel) return;

      const preorder = isPreorderVariant(variant);
      if (preorder) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.classList.add('product-form__submit--preorder');
        if (btnText) btnText.textContent = btn.dataset.preorderLabel;
        if (note) note.hidden = false;
      } else {
        btn.classList.remove('product-form__submit--preorder');
        if (btnText && btnText.textContent === btn.dataset.preorderLabel && variant && variant.available) {
          btnText.textContent = btn.dataset.addLabel;
        }
        if (note) note.hidden = true;
      }
    };

    // Dawn re-renders parts of the section on variant change; re-sync after.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        setTimeout(() => {
          syncSelected();
          if (event && event.data) applyPreorder(event.data.variant);
        }, 0);
      });
    }

    syncSelected();
    relocateSizeGuide(info);
  }

  function relocateSizeGuide(info) {
    const opener = info.querySelector('.size-guide-opener');
    if (!opener) return;

    const options = [...info.querySelectorAll('.variant-option')];
    const sizeOption = options.find((f) => {
      const name = (f.dataset.optionName || '').toLowerCase();
      return name === 'size' || name.indexOf('size') !== -1;
    });
    if (!sizeOption) return;

    const header = sizeOption.querySelector('.variant-option__header');
    if (!header) return;

    // Drop the standalone "selected value" (S/M/L is obvious) and use that slot.
    const selected = header.querySelector('[data-selected-value]');
    if (selected) selected.remove();
    header.appendChild(opener);
  }

  document.querySelectorAll('.product__info-container').forEach(initInfo);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.product__info-container').forEach(initInfo);
  });
})();
